import { actions } from "./Reducer";


export const getFavArtisanProductsAction = (customerId) => {
  console.log(customerId, 'customerId')
 return {
    type: actions.GET_FAV_ARTISAN_PRODUCTS,
    payload: customerId
  }
}

export const getFavArtisanProductsSuccessAction = (body) => ({
  type: actions.GET_FAV_ARTISAN_PRODUCTS_SUCCESS,
  payload: body
})


export const removeFavArtisanPoductAction = (customerId, productID) => ({
  type: actions.REM_FAV_ARTISAN_PRODUCTS,
  payload: {
    customerId,
    productID
  }
})

export const removeFavArtisanProductSuccessAction = (productID) => ({
  type: actions.REM_FAV_ARTISAN_PRODUCTS_SUCCESS,
  payload: productID
})


export const setCustomerFavArtisanProductsIsLoadingAction = (isLoading) => ({
  type: actions.SET_CUSTOMER_FAV_ARTISAN_PRODUCTS_LIST_IS_LOADING,
  payload: isLoading,
});

export const setCustomerFavArtisanProductsCountAction = (count) => ({
  type: actions.SET_CUSTOMER_FAV_ARTISAN_PRODUCTS_LIST_COUNT,
  payload: count,
});

export const setSearchValueAction = (value) => ({
  type: actions.SET_CUSTOMER_FAV_ARTISAN_PRODUCTS_SEARCH_VALUE,
  payload: value,
});